import * as React from 'react';


export var Tab = React.memo(function (_a) {
    var _b = _a.active, active = _b === void 0 ? false : _b, title = _a.title, onClick = _a.onClick;
    var classes = 'pluggy tab';
    if (active) {
        classes += ' active';
    }
    return (React.createElement("div", { className: classes, onClick: onClick }, title));
});
